export default function BrandLogo({ className = "", testId }) {
  return (
    <span className={`inline-block ${className}`}>
      <img src="/brand/logo-ink.png" alt="Elevated Psychiatry" className="w-full h-auto dark:hidden" data-testid={testId} />
      <img src="/brand/logo-reverse.png" alt="" aria-hidden="true" className="w-full h-auto hidden dark:block" />
    </span>
  );
}
